import React from 'react';
import { pathOr } from 'ramda';

import { PROJECT_MASS_SIDEBAR } from 'constants/sidebarTypes';
import { SidebarLink } from 'components/common/tableComponents/cellTemplates/base/SidebarLink';

const ProjectMassSidebarLink = props => {
    const text = pathOr('', ['item', 'posname', '0', 'text'], props);

    return <SidebarLink {...props} icon="briefcase" value={text} componentName={PROJECT_MASS_SIDEBAR} />;
};

export default ProjectMassSidebarLink;
